//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {checkAuthor} from '@/utils/utils'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    hasLink: {
      type: Boolean,
      default: true
    },
    canSelect: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    noIcons: {
      type: Boolean,
      default: false
    },
    multiAuthor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      long: false,
      checked: this.checkedPic,
      activeGif: false
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
    queryLang() {
      return this.isEn ? '?lang=en' : ''
    },
    getCurrentPicturesArr() {
      if (!!this.item.pictureThumb && !!this.item.picture) {

        const {pictureThumb, picture} = this.item
        let result
        if (pictureThumb && pictureThumb.length) {
          result = pictureThumb
        } else {
          result = picture
        }
        return result.length > 3 ? result.slice(0, 3) : result
      }
      return null
    },
    authors() {
      const authors = this.item.authors || []
      return authors.map(elem => elem.name).join(', ')
      // return (this.item.authors || []).join(', ')
    },
    pictureUrl() {
      return this.$absoluteImageUrl(this.item.picture)
    },
    checkedPic() {
      return this.item.selected
    }
  },
  mounted() {
    if (this.item.size && this.item.size.width / this.item.size.height > 1.666 || this.item.isKit && this.item.positional === 'horizontal') {
      this.long = true
    }

    const imageGif = this.$refs.imageGif
    if (imageGif) {
      const options = {
        rootMargin: `-160px 0px`,
      }

      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.activeGif = true
          } else {
            this.activeGif = false
          }
        })
      }, options)

      document.querySelectorAll('.picture-gif').forEach(elem => {
        this.observer.observe(elem)
      })
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.unobserve(document.querySelector('footer'))
    }
  },
  methods: {
    checkVerification(item, author) {
      return checkAuthor(item, author)
    },
    toggleSelect() {
      if (this.canSelect || this.item.selected) {
        this.item.selected = !this.item.selected
        this.$emit('select')
      }
    }
  }
}
